module.exports = __webpack_public_path__ + "media/battleTick.76490ccb.mp3";